<template>
  <div class="app-container">
    <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="68px">
      <el-form-item label="打印编号">
        <el-input v-model="queryParams.printNo_id" placeholder="请输入打印编号" clearable size="small" />
      </el-form-item>
      <el-form-item label="打印名称">
        <el-input v-model="queryParams.print_name" placeholder="请输入打印名称" clearable size="small" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :loading="loading" size="mini"
          @click="handleQuery">查询</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="gap"></div>
    <div style="text-align: left; padding-left: 20px;">
      <el-button type="primary" icon="el-icon-add" :loading="loading" size="mini" @click="handleAdd">新增</el-button>
    </div>
    <el-table v-loading="loading" :data="list">
      <el-table-column label="打印序号" align="center" label-class-name='title' prop="id" />
      <el-table-column label="打印编号" align="center" label-class-name='title' prop="printNo_id" />
      <el-table-column label="打印名称" align="center" label-class-name='title' prop="print_name" />
      <el-table-column label="操作" align="center" width="200" label-class-name='title'
        class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button class="inspect-button" size="mini" type="primary" icon="el-icon-edit"
            @click="printTest(scope.row)">测试</el-button>
          <el-button class="inspect-button" size="mini" type="primary" icon="el-icon-edit"
            @click="handleUpdate(scope.row)">修改</el-button>
          <el-button class="inspect-button" size="mini" type="danger" icon="el-icon-delete"
            @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-show="total > 0" :total="total" @current-change="getList" @prev-click='getList'
      @next-click="getList" />

    <el-dialog :title="dialogTitle" :visible.sync="open" :close-on-click-modal="false" width="500px" append-to-body>
      <el-form ref="form" :model="form" label-width="100px" size="mini">
        <el-row>
          <el-col :span="24">
            <el-form-item label="打印编号">
              <el-input v-model="form.printNo_id" placeholder="请输入打印编号" clearable size="small" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="打印名称">
              <el-input v-model="form.print_name" placeholder="请输入打印名称" clearable size="small" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="open = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { printNoAdd, printNoList, printNoDelete, printNoUpdate, printNoPrint } from '../api/printNo/index'
export default {
  name: 'PrintNo',
  data () {
    return {
      list: [],
      form: {},
      open: false,
      dialogTitle: '打印机新增',
      pageIndex: 1,
      pageSize: 10,
      queryParams: {},
      loading: false,
      total: 0
    }
  },

  created () {
    let flag = sessionStorage.getItem('login')
    if (!flag) {
      this.$router.push('/')
    }
    this.handleQuery()
  },
  methods: {
    //  打印测试
    printTest (row) {
      let params = {
        printNo_id: row.printNo_id,
        content: '打印机连接正常'
      }
      printNoPrint(params).then(res => {
        this.$message.success('测试成功')
      })
    },
    handleUpdate (row) {
      this.open = true
      this.dialogTitle = '打印机修改'
      this.form = row
    },
    handleDelete (row) {
      let params = {
        id: row.id
      }

      this.$confirm('确认删除吗？')
        .then(() => {
          printNoDelete(params).then(res => {
            this.$message.success('删除成功')
            this.handleQuery()
          })
        })
        .catch(_ => {})
    },
    submit () {
      let params = this.form
      if (!params.printNo_id) {
        return this.$message.error('请输入打印编号')
      }
      if (!params.id) {
        printNoAdd(this.form).then(res => {
          this.$message.success('新增成功')
          this.open = false
          this.handleQuery()
        })
      } else {
        printNoUpdate(this.form).then(res => {
          this.$message.success('修改成功')
          this.open = false
          this.handleQuery()
        })
      }
    },

    handleAdd () {
      this.open = true
      this.dialogTitle = '打印机新增'
      this.form = {}
    },
    handleQuery () {
      let params = this.queryParams
      params.pageIndex = this.pageIndex
      params.pageSize = this.pageSize

      this.list = []
      printNoList(params).then(res => {
        this.list = res.data.list
        this.total = res.data.total
      })
    },
    resetQuery () {
      this.queryParams = {
        printNo_id: '',
        print_name: ''
      }
      this.pageIndex = 1
      this.handleQuery()
    },
    getList (e) {
      this.pageIndex = e
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      printNoList(params).then(res => {
        this.list = res.data.list
        this.total = res.data.total
      })
    }
  }
}
</script>
<style>
.app-container {
  margin-top: 40px;
}

.gap {
  margin: 30px 10px;
}

.title {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/views/printNo.vue